import type { FC, HTMLProps } from 'react'
import { extractProps } from './extractProps'
import { InputLayout, type InputLayoutControlProps, type StripInputProps } from './InputLayout'
import { inputCssClass } from './inputCss'

export type DateInputProps = StripInputProps<HTMLProps<HTMLInputElement>> &
  InputLayoutControlProps & { type: 'date'; ref?: React.Ref<HTMLInputElement> }

export const DateInput: FC<DateInputProps> = (props) => {
  const [layoutProps, inputProps] = extractProps(props)

  return (
    <InputLayout {...layoutProps}>
      <input className={inputCssClass} {...inputProps} />
    </InputLayout>
  )
}
